import { AppState } from '../root.reducer';

export const getCreatedOrganizationGroup = (state: AppState) => state.organizationGroup.createdOrganizationGroup;

export const getCreateOrganizationGroupRequestId = (state: AppState) => state.organizationGroup.createRequestId;
